module.exports = {
      id: "icon-warning-2-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-warning-2",
      toString: function () {
        return this.url;
      }
    }